import s from './Hero.module.scss';
import { CheckCheck, Download, ExternalLink, Github, Linkedin, Mail } from 'lucide-react';
import { useState } from 'react';
import { handleCopy } from '../../utils';
import { Button } from '../Button/Button';
import { useMedia } from '../../hooks/useMedia';
import { experiences } from '../Experience/consts';

export default function Hero() {
  const [emailButtonState, setEmailButtonState] = useState(false);
  const [emailIconState, setEmailIconState] = useState(false);
  const { isMobile } = useMedia();


  const copyEmail = () => {
    handleCopy('iliebanik@gmail.com');
    setEmailButtonState(true);
    setTimeout(() => {
      setEmailButtonState(false);
    }, 2000);
  };

  // link
  const handleEmailClick = (e: React.MouseEvent) => {
    e.preventDefault();
    handleCopy('iliebanik@gmail.com');
    setEmailIconState(true);
    setTimeout(() => {
      setEmailIconState(false);
    }, 2000);
  };

  return (
    <section id="about">
      <div className={s.root_wrapper}>
        <div className={s.root}>
          <div className={s.image}><img src="/images/photo.webp" alt="logo preview" /></div>
          <h1>Chebanik Ilia</h1>
          <p>Fullstack / AI Product Engineer</p>
          <p>
            I build modern web applications and AI-powered products, working across
            frontend, backend, and AI integrations. I specialize in React, TypeScript,
            Python, and modern AI technologies.
          </p>
          <div className={s.info}>
            <div className={s.item}>
              <p>3+</p>
              <p>years of experience</p>
            </div>
            <div className={s.item}>
              <p>{experiences.reduce((acc, exp) => acc + exp.experiences.length, 0)}+</p>
              <p>projects</p>
            </div>
            <div className={s.item}>
              <p>100%</p>
              <p>quality</p>
            </div>
          </div>
          <div className={s.buttons}>
            <Button variant="primary" text={emailButtonState ? 'Copied' : 'Contact me'} icon={<Mail size={16} />}
              onClick={copyEmail} />
            <Button variant="secondary" text={isMobile ? 'Download CV' : 'Open CV'}
              icon={isMobile ? <Download size={16} /> : <ExternalLink size={16} />}
              onClick={() => window.open('/docs/CV.pdf', '_blank')} />
          </div>
          <div className={s.links}>
            <a
              className={s.link}
              href="https://github.com/CHchisho"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Chebanik Ilia's GitHub profile"
              title="GitHub: Chebanik Ilia"
            >
              <Github size={20} aria-hidden="true" focusable="false" />
            </a>
            <a
              className={s.link}
              href="https://www.linkedin.com/in/ilia-chebanik/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Chebanik Ilia's LinkedIn profile"
              title="LinkedIn: Chebanik Ilia"
            >
              <Linkedin size={20} aria-hidden="true" focusable="false" />
            </a>
            <div className={s.link} onClick={handleEmailClick}>
              {emailIconState ? <CheckCheck size={20} /> : <Mail size={20} />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
